<template>
  <InfoModal title="Bjud in" mobile-full-width @click="$emit('close')">
    <InviteWrapper
      v-if="!isBroker"
      role-type="transferee"
      :application-id="applicationId"
      :active-invites="activeInvites"
      :is-disabled="fetchingInvitations"
      @getInvitations="getInvitations"
    >
      <template slot="title">Övertagarens e-post</template>
      <template slot="content">
        / Här kan du bjuda in personen som ska
        <strong><u>övertaga</u></strong> genom att ange ange dennes e-post.
        Personen kommer att få ett mail med
        <strong>en inbjudanslänk</strong>
        som man behöver acceptera. Sedan kan de ange
        <strong>sina egna uppgifter och ladda upp dokument</strong>.</template
      >
    </InviteWrapper>
    <template v-else>
      <InviteWrapper
        role-type="transferor"
        :active-invites="activeInvites"
        :application-id="applicationId"
        :is-disabled="fetchingInvitations"
        @getInvitations="getInvitations"
      >
        <template slot="title">Överlåtarens e-post</template>
        <template slot="content">
          / Här kan du bjuda in personen som ska
          <strong><u>överlåta</u></strong> genom att ange dennes e-post.
          Personen kommer att få ett mail med
          <strong>en inbjudanslänk</strong>
          som man behöver acceptera. Sedan kan de ange
          <strong>sina egna uppgifter och ladda upp dokument</strong>.</template
        >
      </InviteWrapper>
      <InviteWrapper
        role-type="transferee"
        :active-invites="activeInvites"
        :application-id="applicationId"
        :is-disabled="fetchingInvitations"
        @getInvitations="getInvitations"
      >
        <template slot="title">Övertagarens e-post</template>
        <template slot="content">
          / Här kan du bjuda in personen som ska
          <strong><u>övertaga</u></strong> genom att ange ange dennes e-post.
          Personen kommer att få ett mail med
          <strong>en inbjudanslänk</strong>
          som man behöver acceptera. Sedan kan de ange
          <strong>sina egna uppgifter och ladda upp dokument</strong>.</template
        >
      </InviteWrapper>
    </template>
  </InfoModal>
</template>

<script>
import { mapGetters } from 'vuex';
import applicationService from '@/services/applicationService';
import { validEmail } from '@/utils/input-validations';
import svgs from '@/utils/icon-constants';

import InfoModal from '@/components/InfoModal.vue';
import InviteWrapper from '@/components/InviteWrapper.vue';

export default {
  name: 'OvInviteModal',
  components: {
    InfoModal,
    InviteWrapper
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      email: '',
      transfereeEmail: '',
      loading: false,
      activeInvites: [],
      validEmail,
      svgs,
      fetchingInvitations: false
    };
  },
  computed: {
    ...mapGetters({
      isBroker: 'ovApplication/isBroker'
    })
  },
  created() {
    this.getInvitations();
  },
  methods: {
    async getInvitations() {
      try {
        this.fetchingInvitations = true;
        const data = await applicationService.getOverlatelseInvite(
          this.applicationId
        );
        this.activeInvites = data || [];
      } catch {
        this.activeInvites = [];
      } finally {
        this.fetchingInvitations = false;
      }
    }
  }
};
</script>
